import { PrimeIcons } from "primeng/api"

import { LgkNavMenuItem } from "@logick/ui/api"

export const CATALOG_MENU: LgkNavMenuItem = {
    label: "Catalogue",
    icon: PrimeIcons.BOOK,
    routerLink: "catalog",
    items: [
        {
            label: "Événementiel",
            type: "section",
            featureState: { isLocked: true },
            items: [
                {
                    label: "Événements",
                    routerLink: "events",
                    routing: { loadComponent: () => import("@/features/catalog/shows/shows.page").then((it) => it.ShowsPage) }
                },
                {
                    label: "Cinémas",
                    routerLink: "cinemas",
                    routing: { loadComponent: () => import("@/features/catalog/cinemas/cinemas.page").then((it) => it.CinemasPage) }
                }

            ]
        },
        {
            label: "Avantages",
            type: "section",
            items: [
                {
                    label: "Adhésions",
                    routerLink: "memberships",
                    routing: { loadComponent: () => import("@/features/catalog/memberships/memberships.page").then((it) => it.MembershipsPage) }
                }, {
                    label: "Bons d'achat",
                    routerLink: "bons",
                    routing: { loadComponent: () => import("@/features/catalog/multi-partner-vouchers/multi-partner-vouchers.page").then((it) => it.MultiPartnerVouchersPage) }
                },
                {
                    label: "Codes promo",
                    routerLink: "promocodes",
                    routing: { loadComponent: () => import("@/features/catalog/promocodes/promocodes.page").then((it) => it.PromoCodesPage) }
                },
            ]
        },
        {
            label: "Paramètres",
            type: "section",
            items: [
                {
                    label: "Lieux",
                    routerLink: "venues",
                    routing: { loadComponent: () => import("@/features/catalog/venues/venues.page").then((it) => it.VenuesPage) }
                },
                {
                    label: "Catégories d'événement",
                    routerLink: "show_categories",
                    routing: { loadComponent: () => import("@/features/catalog/show-categories/show-categories.page").then((it) => it.ShowCategoriesPage) }
                },
                {
                    label: "Tarifs",
                    routerLink: "rates",
                    routing: { loadComponent: () => import("@/features/catalog/rates/rates.page").then((it) => it.RatesPage) }
                },
                {
                    label: "Grilles tarifaires",
                    routerLink: "price_agreement_grids",
                    routing: { loadComponent: () => import("@/features/catalog/price-agreement-grids/price-agreement-grids.page").then((it) => it.PriceAgreementGridsPage) }
                }
            ]
        },

    ]
}